export const categories = [
  {
    id: "all",
    title: "All",
  },
  {
    id: "react",
    title: "React",
  },
  {
    id: "vue",
    title: "Vue",
  },
  {
    id: "nextjs",
    title: "Next.js",
  },
  {
    id: "nuxtjs",
    title: "Nuxt.js",
  },
  {
    id: "typescript",
    title: "TypeScript",
  },
  {
    id: "full-stack",
    title: "Full-stack",
  },
  {
    id: "vanillajs",
    title: "Vanilla JS",
  },
  {
    id: "tailwind",
    title: "TailwindCSS",
  },
];

export const portfolio = [
  {
    id: 1,
    tag: ['all', 'vue', 'nuxtjs', 'tailwind'],
    title: 'Nuxt 2 - Airbnb clone',
    created: 'In progress...',
    details: 'Practising Vue Nuxt 2 features. Final version will be upgraded to Nuxt 3. Still in progress, check out details on github.',
    img: '/images/portfolio/airbnb.png',
    github: 'https://github.com/MarcinBieniek/Vue-NuxtAribnb'
  },
  {
    id: 2,
    tag: ['all', 'react', 'nextjs', 'typescript', 'tailwind'],
    title: 'Next.js full-stack - Dribble clone',
    created: '09/2023',
    details: 'Project created in React Next 13 and Typescript. Inspired by the dribble portal. Allows authorization (Grafbase) as well as adding (with files), editing and deleting projects. Styling in Tailwind.',
    img: '/images/portfolio/dribble.png',
    link: 'https://react-next-js-dribble-clone.vercel.app',
    github: 'https://github.com/MarcinBieniek/React-NextJS-DribbleClone'
  },
  {
    id: 3,
    tag: ['all', 'react', 'full-stack'],
    title: 'React full-stack - E-commerce',
    created: '12/2022',
    details: 'Project created 100% from scratch (own idea and graphics). User registration/login and profile. Product personalization, cart, order process. Orders history.',
    img: '/images/portfolio/prospero.png',
    link: 'https://prospero-store.herokuapp.com/',
    github: 'https://github.com/MarcinBieniek/ProsperoStore'
  },
  {
    id: 4,
    tag: ['all', 'vue', 'nuxtjs', 'typescript', 'tailwind'],
    title: 'Nuxt.js - Movie data base',
    created: '07/2023',
    details: 'Movie data base using omdbAPI. Project made with Nuxt 3 (Pinia, TypeScript, login & auth) and styled with Tailwind.',
    img: '/images/portfolio/movies.png',
    link: 'https://rad-dragon-e353b9.netlify.app/',
    github: 'https://github.com/MarcinBieniek/Vue-NuxtMovies'
  },
  {
    id: 5,
    tag: ['all', 'react', 'nextjs', 'full-stack'],
    title: 'Next.js - Blog',
    created: '08/2023',
    details: 'Blog page created with React Next.js 13. Website allows to login and publish/delete new posts. I used following libraries: mongoose, next, next-auth, swr.',
    img: '/images/portfolio/techmania.png',
    github: 'https://github.com/MarcinBieniek/React-NextJS-Blog'
  },
  {
    id: 6,
    tag: ['all', 'react', 'full-stack'],
    title: 'React full-stack - Real Estate',
    created: '02/2023',
    details: 'Web integrated with interactive map API. User can register/login and perform CRUD operations on offers.',
    img: '/images/portfolio/realestate.png',
    link: 'https://realestate-mb.herokuapp.com/',
    github: 'https://github.com/MarcinBieniek/Fullstack-NoticeBoard'
  },
  {
    id: 7,
    tag: ['all', 'vue', 'nuxtjs', 'typescript', 'tailwind'],
    title: 'Nuxt.js - Trello board',
    created: '06/2023',
    details: 'Trello board created with Nuxt 3 and Tailwind. In the project I used additional libraries, such as Vue Draggable and VueUse (I used useLocalStorage to manage data).',
    img: '/images/portfolio/trello.png',
    link: 'https://main--moonlit-unicorn-c33779.netlify.app/',
    github: 'https://github.com/MarcinBieniek/Vue-Nuxt3TrelloBoard'
  },
  {
    id: 8,
    tag: ['all', 'react'],
    title: 'React - Portfolio web (this site)',
    created: '04/2023',
    details: 'Single page porfolio web with snap-scroll effect.',
    img: '/images/portfolio/portfolio.png',
    github: 'https://github.com/MarcinBieniek/Portfolio'
  },
  {
    id: 9,
    tag: ['all', 'vue', 'tailwind'],
    title: 'Vue & Tailwind - Landing page',
    created: '07/2023',
    details: 'Landing page project for an automotive service. Built with Vue 3, Tailwind and additional Animate.css animation library.',
    img: '/images/portfolio/porsche.png',
    link: 'https://jolly-jelly-338a89.netlify.app/',
    github: 'https://github.com/MarcinBieniek/Vue-Tailwind'
  },
  {
    id: 10,
    tag: ['all', 'vanillajs'],
    title: 'VanillaJS - Simple streaming service',
    created: '06/2022',
    details: 'VanillaJS. Streaming service with audio player, songs list, search page and song draw page.',
    img: '/images/portfolio/streaming.png',
    link: 'https://streaming-service.herokuapp.com/',
    github: 'https://github.com/MarcinBieniek/SimpleStreamingService'
  },
  {
    id: 11,
    tag: ['all', 'react'],
    title: 'React - Group project',
    created: '09/2022',
    details: 'E-commerce group project, lead by PM in Kanban methodology. Git workflow (code rev, merge).',
    img: '/images/portfolio/bazaar.png',
    github: 'https://github.com/MarcinBieniek/wdp-2208-01'
  },
]